/**
 * Created by saeed on 12/29/2016.
 */
import { Injectable }     from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {Observable} from 'rxjs/Rx';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {
  API_URL_SERVICE_SESSION_TIMES_BY_SERVICE_ID_AND_SERVANT_ID,
  API_URL_SERVICE_SESSION_DATES_BY_SERVICE_ID_AND_SERVANT_ID,
  API_URL_ROOT_CATEGORIES_BY_KEY_URL,
  API_URL_SERVICES_BY_CATEGORY_ID,
  API_URL_CATEGORIES_BY_PARENT_ID,
  API_URL_SERVICE_DETAIL_BY_SERVICE_ID,
  API_URL_PROMOTED_SERVICES_BY_COMPANY_ID,
  API_URL_SERVICE_SESSION_DATES_BY_SERVICE_ID,
  API_URL_SERACH_SERVICE_ITEM,
  API_URL_SERVICES_HEADER_BY_CATEGORY_ID,
  API_URL_SERVICE_SESSION_TIMES_BY_SERVICE_ID,
  API_URL_GET_SELECTOR_DATA_BY_TYPE_ID,
  API_URL_GET_ALL_AVAILABLE_TIMES_BY_SERVICE_SERVANT
} from '../constants';
import {CategoryVM} from "../../models/CategoryVM.model";
import {ServiceItemVM} from "../../models/ServiceItemVM";
import {ServiceItemDetailVM} from "../../models/ServiceItemDetailVM";
import {SessionDateVM} from "../../models/SessionDateVM.model";
import {SessionTimeVM} from "../../models/SessionTimeVM.model";
import {BaseHttpService} from "../base-http-service";


@Injectable()
export class CategoryService {
  // Resolve HTTP using the constructor
  constructor(private http:BaseHttpService) {


  }

  // private instance variable to hold base url


  public getRootCategories(keyUrl:string):Observable<CategoryVM[]> {

    // ...using get request

    return this.http.get(API_URL_ROOT_CATEGORIES_BY_KEY_URL + '?url=' + keyUrl)
      // ...and calling .json() on the response to return data
      .map((res:CategoryVM[]) => {

        try {
         this.sortCategoryItems(res);
        } catch (ex) {

        }

        return res;

      })
      //...errors if any
      .catch((error:any) => Observable.throw(error || 'Server error'));


  }

  getCategoriesByParentId(id:Number):Observable<CategoryVM[]> {
    return this.http.get(API_URL_CATEGORIES_BY_PARENT_ID + '/' + id)
      // ...and calling .json() on the response to return data
      .map((res:any[]) => {
        try {
         this.sortCategoryItems(res);
        } catch (ex) {

        }
        return res;
      })
      //...errors if any
      .catch((error:any) => Observable.throw(error || 'Server error'));

  }

  getServiceItemsByCategoryId(id:Number):Observable<ServiceItemVM[]> {
    return this.http.get(API_URL_SERVICES_BY_CATEGORY_ID + '/' + id)
      // ...and calling .json() on the response to return data
      .map((res:any[]) => {
        try {
          res.sort((a, b) => {
            if (a.orderNumber && b.orderNumber)
              return (a.orderNumber < b.orderNumber ? -1 : 1);
            else
              return (a.itemTitle < b.itemTitle ? -1 : 1);
          });
        } catch (ex) {

        }
        return res;
      })
      //...errors if any
      .catch((error:any) => Observable.throw(error || 'Server error'));

  }

  getServiceItemsHeaderByCategoryId(id:Number):Observable<ServiceItemVM[]> {
    return this.http.get(API_URL_SERVICES_HEADER_BY_CATEGORY_ID + '/' + id)
      // ...and calling .json() on the response to return data
      .map((res:any[]) => {
        try {

          this.sortServiceItems(res);

        } catch (ex) {

        }
        return res;
      })
      //...errors if any
      .catch((error:any) => Observable.throw(error || 'Server error'));

  }

  getPromotedServiceItemsByCompanyId(id:Number):Observable<ServiceItemVM[]> {
    return this.http.get(API_URL_PROMOTED_SERVICES_BY_COMPANY_ID + '/' + id)
      // ...and calling .json() on the response to return data
      .map((res:any[]) => {
        try {
          this.sortCategoryItems(res);
        } catch (ex) {

        }
        return res;
      })
      //...errors if any
      .catch((error:any) => Observable.throw(error || 'Server error'));

  }

  getServiceItemDetailById(id:Number):Observable<ServiceItemDetailVM> {
    return this.http.get(API_URL_SERVICE_DETAIL_BY_SERVICE_ID + '/' + id)
      // ...and calling .json() on the response to return data
      .map((res:Response) => {

        return res;
      })
      //...errors if any
      .catch((error:any) => Observable.throw(error || 'Server error'));

  }

  getServiceSessionDatesByServiceid(serviceid:number, from:Date, to:Date):Observable<SessionDateVM[]> {
    return this.http.get(API_URL_SERVICE_SESSION_DATES_BY_SERVICE_ID + '?serviceItemId=' + serviceid + '&from=' + from.toISOString() + '&to=' + to.toISOString())
      // ...and calling .json() on the response to return data
      .map((res:Response) => {
        return res;
      })
      //...errors if any
      .catch((error:any) => Observable.throw(error || 'Server error'));
  }

  getServiceSessionTimesByServiceid(serviceid:number, currentTime:Date):Observable<SessionTimeVM[]> {
    let month = currentTime.getMonth() + 1;
    let monthstr = month.toString();
    if (month < 10)monthstr = '0' + monthstr;
    let day = currentTime.getDate();
    let daystr = day.toString();
    if (day < 10)daystr = '0' + daystr;
    let isoFormat = currentTime.getFullYear() + '-' + monthstr + '-' + daystr + 'T00:00:00.000Z';
    return this.http.get(API_URL_SERVICE_SESSION_TIMES_BY_SERVICE_ID + '?serviceItemId=' + serviceid + '&dateTimeStr=' + isoFormat)
      // ...and calling .json() on the response to return data
      .map((res:Response) => {
        return res;
      })
      //...errors if any
      .catch((error:any) => Observable.throw(error || 'Server error'));
  }

  getSelectorDataByTypeId(typeid:number):Observable<any[]> {

    return this.http.get(API_URL_GET_SELECTOR_DATA_BY_TYPE_ID + '/' + typeid)
      // ...and calling .json() on the response to return data
      .map((res:Response) => {
        return res;
      })
      //...errors if any
      .catch((error:any) => Observable.throw(error || 'Server error'));
  }

  public searchServiceItems(query:string, page:string):Observable<ServiceItemVM[]> {

    return this.http.get(API_URL_SERACH_SERVICE_ITEM + '?query=&page=0&size=20&sort=id,asc')
      // ...and calling .json() on the response to return data
      .map((res:Response) => {
        return res;
      })
      //...errors if any
      .catch((error:any) => Observable.throw(error || 'Server error'));


  }

  getServiceCustomSetting(serviceItem:ServiceItemVM, key) {

    let value;
    if (serviceItem && serviceItem.customSetting) {
      var customSetting = JSON.parse(serviceItem.customSetting);
      if (customSetting[key])
        value = customSetting[key];

    }
    return value;
  }

  getServiceSessionDatesByServiceidAndServant(serviceid:number,servantid:number, from:Date, to:Date):Observable<SessionDateVM[]> {
   let url=API_URL_SERVICE_SESSION_DATES_BY_SERVICE_ID_AND_SERVANT_ID + '?serviceId=' + serviceid  + '&from=' + from.toISOString() + '&to=' + to.toISOString();
    if(servantid)
    url+='&servantid=' + servantid;
    return this.http.get(url)
      // ...and calling .json() on the response to return data
      .map((res:Response) => {
        return res;
      })
      //...errors if any
      .catch((error:any) => Observable.throw(error || 'Server error'));
  }

  getServiceSessionTimesByServiceidAndServant(serviceid:number,servantid:number, currentTime:Date):Observable<SessionTimeVM[]> {
    let month = currentTime.getMonth() + 1;
    let monthstr = month.toString();
    if (month < 10)monthstr = '0' + monthstr;
    let day = currentTime.getDate();
    let daystr = day.toString();
    if (day < 10)daystr = '0' + daystr;
    let isoFormat = currentTime.getFullYear() + '-' + monthstr + '-' + daystr + 'T00:00:00.000Z';
    let url=API_URL_SERVICE_SESSION_TIMES_BY_SERVICE_ID_AND_SERVANT_ID + '?serviceId=' + serviceid + '&dateTimeStr=' + isoFormat;
    if(servantid)
    url+= '&servantid=' + servantid;
    return this.http.get(url)
      // ...and calling .json() on the response to return data
      .map((res:Response) => {
        return res;
      })
      //...errors if any
      .catch((error:any) => Observable.throw(error || 'Server error'));
  }


  getAllAvailableTimesByServiceAndServant(serviceid:number,servantid:number):Observable<SessionTimeVM[]> {

    let url=API_URL_GET_ALL_AVAILABLE_TIMES_BY_SERVICE_SERVANT+ '?serviceId=' + serviceid ;
    if(servantid)
      url+= '&servantid=' + servantid;
    return this.http.get(url)
    // ...and calling .json() on the response to return data
      .map((res:Response) => {
        return res;
      })
      //...errors if any
      .catch((error:any) => Observable.throw(error || 'Server error'));
  }

  sortServiceItems(items){

    items.sort((a, b) => {

      if (a.orderNo && b.orderNo)
        return (a.orderNo - b.orderNo < 0 ? -1 : 1);
      else if (a.orderNo == null && b.orderNo)
          return 1;
      else if (a.orderNo && b.orderNo == null )
        return -1;
      else
        return (a.itemTitle < b.itemTitle ? -1 : 1);
    });
  }

  sortCategoryItems(items){

    items.sort((a, b) => {

      if (a.orderNumber && b.orderNumber)
        return (a.orderNumber < b.orderNumber ? -1 : 1);
      else if (a.orderNumber == null && b.orderNumber)
        return 1;
      else if (a.orderNumber && b.orderNumber == null )
        return -1;
      else
        return (a.categoryName < b.categoryName ? -1 : 1);
    });
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/category/category.service.ts